import { memberStorage } from 'utils';

export const stateProvider = ($stateProvider, $urlServiceProvider) => {
  'ngInject';

  $urlServiceProvider.rules.otherwise({ state: 'login' });

  $stateProvider
    // Shared sections
    .state('login', {
      url: '/',
      component: 'login',
    })
    .state('logout', {
      url: '/logout',
      component: 'logout',
    })
    .state('resetPassword', {
      url: '/reset-password?email&reset_password_token',
      component: 'resetPassword',
    })
    .state('welcome', {
      url: '/welcome',
      component: 'welcomeSteps',
      authenticate: true,
    })
    .state('welcomeUpgrade', {
      url: '/welcome/upgrade/{slug:string}',
      component: 'welcomeSteps',
      authenticate: true,
    })

    // SignUp
    .state('signup', {
      url: `/sign-up?programId&voomeProductId&coupon&coupon_code&utm_params&campaign_channel_medium`,
      onEnter($state) {
        const redirect = () => {
          const {
            utm_params,
            campaign_channel_medium,
            coupon,
            coupon_code,
            programId,
            voomeProductId,
          } = $state.params;

          const params = {
            utm_params,
            campaign_channel_medium,
            coupon: coupon || coupon_code,
            voomeProductId: programId || voomeProductId,
          };

          if (params.voomeProductId) {
            $state.go('signupProgramsDetail', params);
          } else {
            $state.go('signupWeekly', { ...params, slug: 'voome-bundle' });
          }
        };

        window.setTimeout(redirect, 1);
      },
    })
    .state('signupVerify', {
      url:
        '/sign-up/verify?api_id&call_id&nonce&result_code&signature&status_code&timestamp&voome_product_id',
      component: 'signup',
    })
    .state('signupPrograms', {
      url: '/sign-up/programs?utm_params&campaign_channel_medium',
      redirectTo: {
        state: 'signupProgramsDetail',
        params: { voomeProductId: 1 },
      },
    })
    .state('signupProgramsDetail', {
      url:
        '/sign-up/programs/{voomeProductId:int}?utm_params&campaign_channel_medium',
      component: 'signup',
    })
    .state('signupProgram', {
      url:
        '/sign-up/program/{voomeProductId:int}?utm_params&campaign_channel_medium',
      component: 'signup',
    })
    .state('signupWeekly', {
      url: '/sign-up/{slug:string}?coupon&utm_params&campaign_channel_medium',
      component: 'signup',
    })

    // Weekly
    .state('dashboard', {
      url: '/dashboard',
      component: 'dashboard',
      authenticate: true,
    })
    .state('workoutPlayer', {
      url:
        '/workouts/{exercisePlanId:int}/{id:int}/player?autoplay&continuous&itemId',
      component: 'workoutPlayer',
      authenticate: true,
    })
    .state('profile', {
      url: '/profile',
      component: 'profile',
      authenticate: true,
    })
    .state('profileCreditCard', {
      url:
        '/profile/credit-card/{action:string}?api_id&call_id&nonce&result_code&signature&status_code&timestamp&slug&voome_product_id',
      component: 'creditCardUpdate',
      authenticate: true,
    })

    // Weekly Nutrition
    .state('nutrition', {
      url: '/nutrition',
      component: 'nutrition',
      authenticate: true,
      redirectTo: 'nutrition.recipes',
    })
    .state('nutrition.recipes', {
      url: '/recipes?day&filters&level&page&q&serves&order',
      component: 'nutritionRecipes',
      authenticate: true,
    })
    .state('nutrition.recipes.detail', {
      url: '/{recipeId:int}',
      component: 'nutritionRecipe',
      authenticate: true,
    })
    .state('nutrition.hacks', {
      url: '/hacks?page',
      component: 'nutritionHacks',
      authenticate: true,
    })
    .state('nutrition.hacks.recipes', {
      url: '/{hackId:int}/recipes',
      component: 'nutritionHack',
      authenticate: true,
    })
    .state('nutrition.hacks.recipe', {
      url: '/{hackId:int}/recipes/{recipeId:int}',
      component: 'nutritionRecipe',
      authenticate: true,
    })
    .state('nutrition.mealPlans', {
      url: '/meal-plans?type&page',
      component: 'nutritionMealPlans',
      authenticate: true,
    })
    .state('nutrition.mealPlans.detail', {
      url: '/{mealPlanId:int}',
      component: 'nutritionMealPlan',
      authenticate: true,
    })
    .state('nutrition.mealPlans.detail.shoppingList', {
      url: '/shopping-list',
      component: 'shoppingList',
      authenticate: true,
    })
    .state('nutrition.mealPlans.detail.edit', {
      url: '/edit?day&filters&level&q&serves&order&favourites',
      component: 'mealPlanEdit',
      authenticate: true,
    })

    // Weekly Workouts
    .state('workouts', {
      url: '/workouts',
      component: 'workouts',
      authenticate: true,
      redirectTo: 'workouts.videos',
    })
    .state('workouts.videos', {
      url: '/videos?order&page&type&equipmentRequired&time',
      component: 'workoutsVideos',
      authenticate: true,
    })
    .state('workouts.videos.detail', {
      url: '/{videoId:int}',
      component: 'workoutsVideo',
      authenticate: true,
    })
    .state('workouts.express', {
      url: '/express?day&filters&level&page&q&order',
      component: 'workoutsExpress',
      authenticate: true,
    })
    .state('workouts.express.detail', {
      url: '/{exercisePlanId:int}/{id:int}',
      component: 'workoutsDetail',
      authenticate: true,
    })
    .state('workouts.hacks', {
      url: '/hacks?page',
      component: 'workoutsHacks',
      authenticate: true,
    })
    .state('workouts.hacks.exercises', {
      url: '/{hackId:int}/exercises',
      component: 'workoutsHack',
      authenticate: true,
    })
    .state('workouts.hacks.exercise', {
      url: '/{hackId:int}/exercises/{exercisePlanId:int}/{id:int}',
      component: 'workoutsDetail',
      authenticate: true,
    })

    // Weekly Favourites
    .state('favourites', {
      url: '/favourites',
      component: 'favourites',
      authenticate: true,
    })
    .state('favourites.recipes', {
      url: '/recipes?order&page',
      component: 'favouritesRecipes',
      authenticate: true,
    })
    .state('favourites.recipes.detail', {
      url: '/{recipeId:int}',
      component: 'nutritionRecipe',
      authenticate: true,
    })
    .state('favourites.workouts', {
      url: '/workouts?order&page',
      component: 'favouritesWorkouts',
      authenticate: true,
    })
    .state('favourites.workouts.detail', {
      url: '/{exercisePlanId:int}/{id:int}',
      component: 'workoutsDetail',
      authenticate: true,
    })
    .state('favourites.videos', {
      url: '/videos?order&page',
      component: 'favouritesVideos',
      authenticate: true,
    })
    .state('favourites.videos.detail', {
      url: '/{videoId:int}',
      component: 'workoutsVideo',
      authenticate: true,
    })

    // Programs
    .state('program', {
      url: '/program/{voomeProductId:int}',
      component: 'program',
      redirectTo: 'program.intro',
      authenticate: true,
    })
    .state('program.intro', {
      url: '',
      component: 'programIntro',
      authenticate: true,
    })
    .state('program.graduation', {
      url: '/graduation',
      component: 'programGraduation',
      authenticate: true,
    })
    .state('program.profile', {
      url: '/profile',
      component: 'profile',
      authenticate: true,
    })
    .state('program.week', {
      url: '/week/{weekNumber:int}',
      redirectTo: 'program.week.detail',
      authenticate: true,
    })
    .state('program.week.detail', {
      component: 'programWeek',
      authenticate: true,
    })
    .state('program.week.mealPlan', {
      url: '/meal-plan/{mealPlanId:int}',
      component: 'programMealPlan',
      authenticate: true,
    })
    .state('program.week.mealPlan.shoppingList', {
      url: '/shopping-list',
      component: 'shoppingList',
      authenticate: true,
    })
    .state('program.week.mealPlan.edit', {
      url: '/edit?day&filters&level&page&q&serves&order&favourites',
      component: 'mealPlanEdit',
      authenticate: true,
    })
    .state('program.week.workout', {
      url: '/workout/{exercisePlanId:int}/{id:int}',
      component: 'programWorkout',
      authenticate: true,
    })
    .state('program.week.recipe', {
      url: '/recipe/{recipeId:int}',
      component: 'programRecipe',
      authenticate: true,
    })

    // Program Redirects - confirm if we still need this
    .state('program.week.mealPlanRedirect', {
      url: '/meal-plan',
      component: 'programRedirect',
      authenticate: true,
    })
    .state('program.week.shoppingListRedirect', {
      url: '/shopping-list',
      component: 'programRedirect',
      authenticate: true,
    })

    // Legacy Redirects
    .state('legacy-meal-planner', {
      url: '/meal-planner',
      redirectTo: 'nutrition.mealPlans',
      authenticate: true,
    })
    .state('legacy-recipes', {
      url: '/recipes',
      redirectTo: 'nutrition.recipes',
      authenticate: true,
    })
    .state('legacy-recipes-detail', {
      url: '/recipes/{recipeId:string}',
      authenticate: true,
      onEnter($state) {
        const redirect = () => {
          const recipeId = parseInt($state.params.recipeId, 10);

          recipeId
            ? $state.go('nutrition.recipes.detail', { recipeId })
            : $state.go('nutrition.recipes');
        };

        window.setTimeout(redirect, 1);
      },
    })
    .state('legacy-workouts', {
      url: '/workouts',
      redirectTo: 'workouts.videos',
      authenticate: true,
    })
    .state('legacy-workouts-detail', {
      url: '/workouts/{exercisePlanId:int}/plan/{id:int}',
      authenticate: true,
      onEnter($state) {
        const redirect = () => {
          const { exercisePlanId, id } = $state.params;

          exercisePlanId && id
            ? $state.go('workouts.express.detail', { exercisePlanId, id })
            : $state.go('workouts.videos');
        };

        window.setTimeout(redirect, 1);
      },
    });
};



// WEBPACK FOOTER //
// ./src/providers/stateProvider.js